<template>
	<div>
		<div class="conten">
			<el-row>
				<el-col :span="17">
					<div
						style="padding: 20px 50px;box-sizing: border-box;line-height: 20px;font-size:14px;"
					>
						<div>基础设置</div>
						<el-divider></el-divider>
						<el-form
							ref="form"
							:model="form"
							:rules="rules"
							label-width="120px"
						>
							<el-form-item label="活动名称" prop="prize_name">
								<el-input
									v-model="form.prize_name"
									style="width: 20%;"
									:placeholder="topText"
									maxlength="10"
									show-word-limit
									@input="input"
								></el-input>
							</el-form-item>
							<el-form-item label="活动时间">
								<el-col :span="6">
									<el-date-picker
										type="datetime"
										placeholder="开始日期"
										v-model="form.start_time"
										value-format="yyyy-MM-dd HH:mm:ss"
										style="width: 100%;"
									></el-date-picker>
								</el-col>
								<el-col class="line" :span="0.5"> -- </el-col>
								<el-col :span="17">
									<el-date-picker
										type="datetime"
										placeholder="结束日期"
										v-model="form.end_time"
										value-format="yyyy-MM-dd HH:mm:ss"
										style="width: 40%;"
									></el-date-picker>
								</el-col>
							</el-form-item>
							<el-form-item label="活动人群" prop="resource">
								<el-radio-group v-model="form.population_type">
									<el-radio :label="1">全部会员</el-radio>
									<!-- <el-radio :label="2">部分会员</el-radio> -->
									<el-radio :label="3">会员等级</el-radio>
									<el-radio :label="4">会员标签</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item
								label="客户群体"
								v-if="
									form.population_type == 2 ||
										form.population_type == 3 ||
										form.population_type == 4
								"
								prop="region"
							>
								<el-select
									v-model="form.population_level_ids"
									multiple
									filterable
									collapse-tags
									placeholder="请选择"
									v-if="form.population_type == 3"
								>
									<el-option-group
										v-for="group in level_Group_Select"
										:key="group.anme"
										:label="group.name"
									>
										<el-option
											v-for="item in group.lists"
											:key="item.id"
											:label="item.name"
											:value="item.id"
										>
										</el-option>
									</el-option-group>
								</el-select>
								<el-select
									v-model="form.population_tag_ids"
									multiple
									collapse-tags
									placeholder="请选择"
									filterable
									v-if="form.population_type == 4"
								>
									<el-option
										v-for="item in allTagList"
										:key="item.id"
										:label="item.title"
										:value="item.id"
									>
									</el-option>
								</el-select>
							</el-form-item>
						</el-form>
					</div>
					<div
						style="padding: 20px 50px;box-sizing: border-box;line-height: 20px;font-size:14px;"
					>
						<div>页面设置</div>
						<el-divider></el-divider>
						<el-form
							ref="form"
							:model="form"
							:rules="rules"
							label-width="120px"
						>
							<el-form-item label="活动类型" prop="prize_type">
								<el-radio-group v-model="form.prize_type">
									<el-radio
										v-for="item in radio_items"
										:key="item.value"
										:label="item.value"
										>{{ item.name }}</el-radio
									>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="活动标语" prop="slogan">
								<el-input
									v-model="form.slogan"
									style="width: 20%;"
									maxlength="8"
									show-word-limit
								></el-input>
							</el-form-item>
							<!-- <el-form-item label="活动封面">
								<div class="fengmian">
									<img
										v-for="(item, index) in cover"
										:key="index"
										:src="item"
										alt=""
										:class="activeClass == index ? 'active' : ''"
										@click="getItem(index, item)"
									/>
								</div>
							</el-form-item> -->
							<el-form-item>
								<el-button @click="back">返 回</el-button>
								<el-button type="primary" @click="next('form')"
									>下一步</el-button
								>
							</el-form-item>
						</el-form>
					</div>
				</el-col>
				<!-- <el-col :span="7">
					<div
						style="padding: 20px 50px;box-sizing: border-box;line-height: 20px;font-size:14px;"
					>
						<div>
							预览
						</div>
						<div class="Preview">
							<div class="Preview_top">{{ topText }}</div>
							<div class="Preview_img">
								<img :src="img" alt="" />
								<div class="Preview_img_text">{{ form.slogan }}</div>
							</div>
						</div>
					</div>
				</el-col> -->
			</el-row>
		</div>
		<el-dialog
			:visible.sync="showSelecterUser"
			@close="showSelecterUser = false"
		>
			<selectCommodity
				@close="showSelecterUser = false"
				@getCommod="getCommodUser"
				:sList="sUserList"
				:jude="4"
				:menuName="'会员'"
			></selectCommodity>
		</el-dialog>
	</div>
</template>
<script>
import store from "@/store/index";
import { allTag } from "@/api/market";
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import { levelGroupSelect, lottery_detail } from "@/api/vip";
import time from "@/utils/time";

export default {
	computed: {},
	components: {
		selectCommodity,
	},
	directives: {
		"el-select-loadmmore": {
			bind(el, binding) {
				// 因为el-select最终会渲染成ul  li  ，所以我们要找到对应的ul元素节点，因为最底层的滚动条就是这个ul的
				const SELECTDOM = el.querySelector(
					".el-select-dropdown .el-select-dropdown__wrap"
				);
				// 为对应的ul绑定滚动条滚动事件
				SELECTDOM.addEventListener("scroll", function() {
					const condition =
						this.scrollHeight - this.scrollTop == this.clientHeight;
					// 判断滚动到底部
					if (condition) {
						// binding.value 为自定义指令绑定的值，因为绑定的是个方法，所以这里是方法调用，触发指令后执行加载数据
						binding.value();
					}
				});
			},
		},
	},
	data() {
		return {
			form: {},
			showSelecterUser: false,
			topText: "活动名称",
			cover: [
				"https://prd-1258898587.cos.ap-beijing.myqcloud.com/public/2021/02/02/11/a1d78decc2abd9252ecd09a97547.png",
				"https://yy-1258898587.cos.ap-guangzhou.myqcloud.com/public/2020/04/11/15/58ba4cc7844c54b130417946d4e5.png",
				"https://yy-1258898587.cos.ap-guangzhou.myqcloud.com/public/2020/03/27/15/47cd402d3eeb5fa0383c43ee6d33.png",
			],
			activeClass: 0,
			img:
				"https://prd-1258898587.cos.ap-beijing.myqcloud.com/public/2021/02/02/11/a1d78decc2abd9252ecd09a97547.png",
			options: [],
			value: "",
			level_Group_Select: [],
			allTagList: [],
			alluserList: [],
			sUserList: [],
			newData: [],
			selectUserName: "",
			page: 1,
			rules: {
				prize_name: [
					{ required: true, message: "请输入活动名称", trigger: "blur" },
				],
				slogan: [
					{ required: true, message: "请输入活动标语", trigger: "blur" },
				],
			},
			radio: 1,
			radio_items: [
				{
					name: "大转盘",
					value: 1,
				},
				{
					name: "九宫格",
					value: 2,
				},
				// {
				// 	name: "刮刮乐",
				// 	value: 3,
				// },
				// {
				// 	name: "砸金蛋",
				// 	value: 4,
				// },
				// {
				// 	name: "摇一摇",
				// 	value: 5,
				// },
				// {
				// 	name: "扭蛋机",
				// 	value: 6,
				// },
				// {
				// 	name: "老虎机",
				// 	value: 7,
				// },
			],
		};
	},
	created() {},
	mounted() {
		this.get_levelGroupSelect();
		this.get_allTag();
		// this.get_alluser();
		if (this.$route.query.key == 1) {
			this.get_info();
		} else {
			this.form = store.getters.lotteryfrom;
		}
	},
	methods: {
		//校验时间
		check(startTime, endTime) {
			var date1 = new Date(startTime);
			var date2 = new Date(endTime);
			var time1 = date1.getTime();
			var time2 = date2.getTime();
			if (time1 > time2) {
				return false;
			}
			return true;
		},
		next(formName) {
			if (store.getters.lotteryfrom.prize_name == "") {
				this.$message.error("活动名称不能为空!!!");
				return false;
			}
			if (
				store.getters.lotteryfrom.start_time == "" &&
				store.getters.lotteryfrom.end_time == ""
			) {
				this.$message.error("活动开始至活动结束时间不能为空!!!");
				return false;
			} else {
				if (
					!this.check(
						store.getters.lotteryfrom.start_time,
						store.getters.lotteryfrom.end_time
					)
				) {
					this.$message.error("活动开始时间不能大于结束时间!!!");
					return false;
				}
			}
			if (store.getters.lotteryfrom.slogan == "") {
				this.$message.error("活动标语不能为空!!!");
				return false;
			}
			this.$emit("active", 1);
		},
		async get_info() {
			const res = await lottery_detail({
				app_id: store.getters.app_id,
				id: this.$route.query.id,
			});
			if (res.code == 200) {
				let data = res.data;
				data.population_type = Number(data.population_type);
				data.population_level_ids = data.population_level_ids
					? data.population_level_ids.split(",")
					: [];
				data.population_member_ids = data.population_member_ids
					? data.population_member_ids.split(",")
					: [];
				data.population_tag_ids = data.population_tag_ids
					? data.population_tag_ids.split(",")
					: [];
				data.is_consume = data.is_consume == 1 ? true : false;
        data.is_display = data.is_display == 1 ? true : false;
				data.is_consume_card_consume =
					data.is_consume_card_consume == 1 ? true : false;
				data.is_consume_card_recharge =
					data.is_consume_card_recharge == 1 ? true : false;
				data.is_free = data.is_free == 1 ? true : false;
				data.is_integral = data.is_integral == 1 ? true : false;
				data.consume_products.forEach((item) => {
					item.goods_ids = item.goods_ids
						? item.goods_ids.split(",")
						: item.goods_ids.split("");
				});
				data.consume_card_recharge_cards.forEach((item) => {
					item.goods_ids = item.goods_ids
						? item.goods_ids.split(",")
						: item.goods_ids.split("");
				});
				data.consume_card_consume_cards.forEach((item) => {
					item.goods_ids = item.goods_ids
						? item.goods_ids.split(",")
						: item.goods_ids.split("");
				});
				data.awards.forEach((item, i) => {
				  item.rate = Number(item.rate)
          if(item.user_time == 0){
            item.user_time = "";
          }else{
            item.user_time = time.setTime(item.user_time);
          }
				});
				this.form = data;
				this.$store.dispatch("SETLOTTERY", data);
				this.img = this.form.pic_url;
				this.cover.forEach((item, i) => {
					if (this.form.pic_url == item) {
						this.activeClass = i;
						this.img = item;
					}
				});
				this.topText = store.getters.lotteryfrom.prize_name;
				console.log(typeof this.form.population_member_ids);
				this.form.population_member_ids.forEach((item, i) => {
					this.form.population_member_ids[i] = Number(item);
				});
				this.form.population_level_ids.forEach((item, i) => {
					this.form.population_level_ids[i] = Number(item);
				});
				this.form.population_tag_ids.forEach((item, i) => {
					this.form.population_tag_ids[i] = Number(item);
				});
			}
		},

		population_member_md(val) {
			console.log(val);
			if (val == 2) {
				this.showSelecterUser = true;
			}
		},

		// loadmore() {
		// 	this.page++;
		// 	this.get_alluser();
		// },
		getItem(i, img) {
			this.activeClass = i;
			this.img = img;
			this.form.pic_url = img;
		},
		input(val) {
			this.topText = val;
		},
		back() {
			this.$router.back(-1);
		},
		//会员等级
		async get_levelGroupSelect() {
			const res = await levelGroupSelect({
				app_id: store.getters.app_id,
			});
			if (res.code == 200) {
				this.level_Group_Select = res.data;
			}
		},
		//会员标签
		async get_allTag() {
			const res = await allTag({
				app_id: store.getters.app_id,
			});
			if (res.code == 200) {
				this.allTagList = res.data;
			}
		},
		//会员列表
		// async get_alluser(val) {
		// 	console.log(val);
		// 	let data = {
		// 		app_id: store.getters.app_id,
		// 		page: val ? null : this.page,

		// 	};
		// 	const res = await userList(data);
		// 	if (res.code == 200) {
		// 		if (val) {
		// 			this.alluserList = res.data.result;
		// 		} else {
		//       this.alluserList = this.alluserList.concat(res.data.result);
		//       this.newData = this.newData.concat(res.data.result);
		// 		}
		// 	}
		// },
		getCommodUser(data) {
			console.log("333", data);
			data.forEach((item, i) => {
				this.form;
			});
			this.sUserList = data;
			if (data.length > 5) {
				this.selectUserName =
					data[0].name +
					"," +
					data[1].name +
					"," +
					data[2].name +
					"," +
					data[3].name +
					"," +
					data[4].name +
					"等" +
					data.length +
					"位用户";
			} else {
				this.selectUserName =
					data.map((n) => n.name).join(",") + " 共" + data.length + "位用户";
			}
			this.showSelecterUser = false;
		},
		// async remoteMethod(query) {
		//   this.page = 1
		// 	const res = await userList({
		// 		app_id: store.getters.app_id,
		// 		page: this.page,
		// 		mobile: query,
		//   })
		//   if(res.code == 200) {
		//     this.alluserList = res.data.result;
		//   }
		// },
	},
};
</script>
<style lang="scss" scoped>
.conten {
	width: 95%;
	height: 40vw;
	background-color: #ffffff;
	margin: 20px auto;
	padding: 20px 0;
	// line-height: 5vw;
}
.el-divider {
	margin: 10px 0 !important;
	margin-bottom: 30px !important;
}
.fengmian {
	padding-top: 15px;
	img {
		width: 70px;
		height: 100px;
		margin-right: 10px;
	}
	.active {
		/* background: #eee; */
		// color: #1e82d2;
		box-shadow: #1e82d2 0px 0px 8px;
		// font-weight: bolder;
	}
}
.Preview {
	width: 95%;
	height: 33vw;
	margin: 20px auto;
	background-color: #f8f8f8f8;
	padding: 30px 20px;
	box-sizing: border-box;
	.Preview_top {
		// width: 90;
		height: 2vw;
		background-color: #ffffff;
		text-align: center;
		line-height: 2vw;
	}
	.Preview_img {
		// width: 90%;
		height: 28vw;
		position: relative;
		// background-color: #ffffff;
		// text-align: center;
		// line-height: 2vw;
		.Preview_img_text {
			width: 100%;
			height: 1.5vw;
			// background-color: #000;
			line-height: 1.6vw;
			color: #fff;
			text-align: center;
			position: absolute;
			top: 3.7vw;
			z-index: 100;
		}
		img {
			width: 100%;
			height: 100%;
			// cursor:pointer;
		}
	}
}
</style>
